import clsx from "clsx";
import DefaultImage from "assets/Images/BrandImage1.png";

type Props = {
  name: string;
  brandName: string;
  imageUrl: string;
  disabled?: boolean;
  title?: string;
  additionalClasses?: string;
  cardAdditionalClasses?: string;
  isFeatured?: boolean;
  isMemento?: boolean;
};

interface ClickableCard extends Props {
  isClickable: boolean;
  handleOnClick: () => void;
}
interface ViewOnlyCard extends Props {
  isClickable?: never;
  handleOnClick?: never;
}

function MagnetCard({
  name,
  imageUrl,
  disabled,
  title,
  brandName,
  isMemento,
  additionalClasses = "",
  isClickable = false,
  handleOnClick,
}: ClickableCard | ViewOnlyCard) {
  return (
    <div
      className={clsx(
        "relative flex h-fit  flex-col rounded-xl p-2 shadow-modal transition-shadow duration-100 hover:shadow-xl",
        isClickable && "cursor-pointer",
        isMemento ? "bg-white" : "magnet-card-background border-b-2 border-r-2 border-[#87ACCF]",
      )}
      onClick={handleOnClick}
      title={title}
    >
      <div>
        <div className="aspect-1 w-full">
          <img
            src={imageUrl || DefaultImage}
            alt={name}
            className="h-full w-full rounded-xl border-1 border-white  object-cover"
          />
        </div>
      </div>
      <p
        className={clsx(
          "truncate py-1 text-left font-satoshi text-xs md:py-0.5 md:text-base",
          "font-semibold leading-4 text-primary first-letter:uppercase 2xl:my-1 2xl:text-base",
          additionalClasses,
        )}
      >
        {name}
      </p>
      {brandName && (
        <p
          className="mt-0.5  truncate overflow-ellipsis pb-2 text-left font-satoshi text-[14px] font-semibold leading-3 text-primary text-opacity-50 
         md:mt-0 md:p-0 md:pb-0 md:text-[9px]"
        >
          {brandName}
        </p>
      )}
      {disabled && (
        <div
          title="Your purchase is yet to be settled."
          className="absolute left-0 top-0 h-full w-full rounded-xl
              border-b-2 border-r-2 border-white bg-white opacity-50 
              transition-all hover:opacity-95 active:opacity-100"
          onClick={(e) => {
            e.stopPropagation();
          }}
        />
      )}
    </div>
  );
}
export default MagnetCard;

export function MagnetMobileCard({
  name,
  imageUrl,
  brandName,
  isMemento,
  disabled,
  title,
  additionalClasses = "",
  isClickable = false,
  handleOnClick,
}: ClickableCard | ViewOnlyCard) {
  return (
    <div
      className={clsx(
        "relative flex h-fit flex-col  rounded-xl md:p-2 ",
        isClickable && "cursor-pointer",
        isMemento ? "bg-white" : "magnet-card-background border-b-2 border-r-2 border-[#87ACCF]",
      )}
      onClick={handleOnClick}
      title={title}
    >
      <div className="relative">
        <div className="aspect-h-1 aspect-w-1">
          <img
            src={imageUrl || DefaultImage}
            alt={name}
            className="h-full w-full rounded-md border-1  border-white  object-cover md:rounded-xl"
          />
        </div>
      </div>
      <p
        className={clsx(
          "hidden truncate py-1 text-left font-satoshi text-xs md:py-0.5 md:text-base",
          "font-semibold leading-4 text-primary first-letter:uppercase 2xl:my-1 2xl:text-base",
          additionalClasses,
        )}
      >
        {name}
      </p>
      {brandName && (
        <p
          className="mt-0.5 hidden  truncate overflow-ellipsis pb-2 text-left font-satoshi text-[14px] font-semibold leading-3 text-primary text-opacity-50 
         md:mt-0 md:p-0 md:pb-0 md:text-[9px]"
        >
          {brandName}
        </p>
      )}
      {disabled && (
        <div
          title="Your purchase is yet to be settled."
          className="rounded-ml absolute left-0 top-0 h-full w-full
              border-b-2 border-r-2 border-white bg-white opacity-50 
              transition-all hover:opacity-95 active:opacity-100 md:rounded-xl md:p-2"
          onClick={(e) => {
            e.stopPropagation();
          }}
        />
      )}
    </div>
  );
}
